import { ButtonLink } from '@app/components/base/ButtonLink';
import AddIcon from '@mui/icons-material/Add';
import { useIntl } from 'react-intl';

interface AddButtonProps {
  readonly to: string;
  readonly label?: string;
}

export const AddButton = ({ to, label }: AddButtonProps) => {
  const { formatMessage, $t } = useIntl();

  return (
    <ButtonLink to={to} variant="contained" color="primary" startIcon={<AddIcon />}>
      {label ||
        formatMessage({
          id: 'common.actions.create',
          defaultMessage: 'Crear nuevo',
        })}
    </ButtonLink>
  );
};
